import Vue from 'vue'
import layout from '../compos/layoutMode.vue'
import nodata from '../compos/nodata.vue'
import head from '../compos/header.vue'
import footer from '../compos/footer.vue'

// 公用组件注册
Vue.component('fo-layout', layout) // 宽度布局
Vue.component('fo-nodata', nodata)
Vue.component('fo-header', head)
Vue.component('fo-footer', footer)



// WEBPACK FOOTER //
// ./src/utils/compos.js